export default __webpack_public_path__ + "static/media/supportfit.a58bb0c7.mp4";